module.exports = __webpack_public_path__ + "static/telecommute-app-f129280454b5f03c745a104b7e426e25.png";